import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHFiftyNinePreLogin',
    name: 'IFPageOneHFiftyNinePreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyNine/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHFiftyNineLogin' ||
        from.path === '/IFPageOneHFiftyNineLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHFiftyNineLogin',
    name: 'pageOneHFiftyNineLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyNine/login.vue'),
  },
  {
    path: '/IFPageOneHFiftyNineGuide',
    name: 'pageOneHFiftyNineLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHFiftyNine/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageOneHFiftyNineLoginSecond',
    name: 'pageOneHFiftyNineLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHFiftyNine/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
];
